import { SubmissionError } from 'redux-form';
import fetch from '../../core/fetch';

import messages from '../../locale/messages';
import { getListingData } from '../../actions/getListing';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { getListingFieldsValues } from '../../actions/getListingFieldsValues';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import history from '../../core/history';
import { updateListing as query } from '../../lib/graphql';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

async function update(values, dispatch) {

  let bedTypes, roomType, houseType, bedrooms, buildingSize, bedType, bathroomType, rooms;

  const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: values?.id }));
  if (isRestrict) {
    showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
    return;
  }

  // Handle room-based beds if provided
  if (values?.rooms) {
    rooms = values.rooms; // Already stringified in Page3.js
  } else {
    bedTypes = JSON.stringify(values?.bedTypes);
  }

  roomType = String(values?.roomType);
  houseType = String(values?.houseType);
  bedrooms = String(values?.bedrooms);
  buildingSize = null;
  bedType = String(values?.bedType);
  bathroomType = String(values?.bathroomType);

  let variables = Object.assign({}, values, {
    bedTypes, roomType, houseType, bedType,
    bedrooms, buildingSize, bathroomType, rooms,
    street: "",
    buildingName: "",
    zipcode: ""
  });

  dispatch(setLoaderStart('updateListing'));

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();

  if (data?.updateListing?.status == "success") {
    console.log('[FORM_INIT_DEBUG] update.js - Form submission successful, calling getListingFieldsValues with step="2"');
    await dispatch(manageListingSteps(values.id, 1));
    history.push('/become-a-host/' + values.id + '/home');
    await dispatch(getListingData(values.id));
    await dispatch(getListingFieldsValues("2", values.id));
    await dispatch(setLoaderComplete('updateListing'));
  } else if (data.updateListing.status == "notLoggedIn") {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.notLoggedIn });
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default update;
